import product1 from "../../images/product-1.jpg";
import product2 from "../../images/product-2.jpg";
import product3 from "../../images/product-3.jpg";
import sweet1 from "../../images/sweet-1.jpg";
import sweet2 from "../../images/sweet-2.jpg";
import sweet3 from "../../images/sweet-3.jpg";

export const productData = [
  {
    img: product1,
    alt: "Paneer Tikka",
    name: "Paneer Tikka",
    desc: "Marinated paneer in a spiced yogurt-based marinade, arranged on skewersand",
    price: "Rs 899",
    button: "Add to Cart",
  },
  {
    img: product2,
    alt: "Paneer Butter Masala",
    name: "Paneer Butter Masala",
    desc: " Marinara sauce, basil, italian sausage, roma tomatoes, olives, and pesto",
    price: "Rs 999",
    button: "Add to Cart",
  },
  {
    img: product3,
    alt: "Chilli Chicken",
    name: "Chilli Chicken",
    desc: " Boneless chicken with capcicum, onion, chopped garlic, soy sauce and vinegar",
    price: "Rs 1499",
    button: "Add to Cart",
  },
];

export const productDataTwo = [
  {
    img: sweet2,
    alt: "Donuts",
    name: "Donuts",
    desc: "Belgian chocolate glazed donuts covered in icing with sprinkles on top",
    price: "Rs 599",
    button: "Add to Cart",
  },
  {
    img: sweet3,
    alt: "Ice Cream",
    name: "Ice Cream",
    desc: "Vanilla ice cream covered with caramel and chocolate glaze topped with a coco stick",
    price: "Rs 799",
    button: "Add to Cart",
  },
  {
    img: sweet1,
    alt: "Mango Lassi",
    name: "Mango Lassi ",
    desc: "Double fudge brownie squares topped with white chocolate pieces and macadamia nuts",
    price: "Rs 299",
    button: "Add to Cart",
  },
];
